export default __webpack_public_path__ + "static/media/solid-works.f8c97bc1.png";